import axios from "axios";
import {getServerBaseUrl} from "services/ConfigServices"

export default axios.create({
  baseURL:
  getServerBaseUrl()+"/home?idgroup=4",
});
